export default {"src":"/_next/static/media/stake.c554e739.svg","height":160,"width":219};